import { useLang } from "../contexts/LangContext";
import { Gamepad2, Trophy, Users } from "lucide-react";

export default function Games() {
  const { t } = useLang();
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8">
      <h1 className="text-3xl sm:text-4xl font-bold text-cyan-gradient mb-2 flex items-center gap-3">
        <Gamepad2 className="w-7 h-7" /> {t("games")}
      </h1>
      <p className="text-sm text-[#8FA3BD] mb-8">{t("gamesDesc")}</p>

      <div className="bento-card p-10 text-center relative overflow-hidden">
        <div className="absolute inset-0 opacity-30" style={{
          backgroundImage: "linear-gradient(rgba(0,229,255,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(0,229,255,0.06) 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }} />
        <div className="relative">
          <Gamepad2 className="w-20 h-20 text-[#00E5FF] mx-auto mb-4" />
          <h2 className="text-3xl font-bold text-cyan-gradient mb-3">{t("comingSoon")}</h2>
          <p className="text-sm text-[#8FA3BD] max-w-md mx-auto mb-8">
            دومينو، لودو، وألعاب أخرى. تحدّى أصدقاءك، راهن بمبلغ، والفائز يأخذ المراهنة. الخاسر يحصل على نقاط تُستخدم في الروليت المجاني.
          </p>
          <div className="grid grid-cols-3 gap-3 max-w-md mx-auto">
            {[
              { icon: Users, label: "Domino" },
              { icon: Trophy, label: "Ludo" },
              { icon: Gamepad2, label: "More" },
            ].map((g, i) => {
              const Icon = g.icon;
              return (
                <div key={i} className="bento-card p-4 opacity-50">
                  <Icon className="w-7 h-7 text-[#00E5FF] mx-auto mb-2" />
                  <div className="text-xs">{g.label}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
